import { jsx as b } from "@emotion/react/jsx-runtime";
import l from "@emotion/styled/base";
const d = /* @__PURE__ */ l("div", process.env.NODE_ENV === "production" ? {
  target: "e108ejwv0"
} : {
  target: "e108ejwv0",
  label: "StyledBody"
})("display:flex;flex-direction:column;gap:", ({
  theme: c
}) => c.spaces[2], ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvRGF0YURpc3BsYXkvTGlzdC9Cb2R5LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJNkIiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9EYXRhRGlzcGxheS9MaXN0L0JvZHkudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBQcm9wc1dpdGhDaGlsZHJlbiB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5jb25zdCBTdHlsZWRCb2R5ID0gc3R5bGVkLmRpdmBcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnNwYWNlc1snMiddfTtcbmA7XG5cbmV4cG9ydCBjb25zdCBCb2R5ID0gKHsgY2hpbGRyZW4gfTogUHJvcHNXaXRoQ2hpbGRyZW4pID0+IDxTdHlsZWRCb2R5PntjaGlsZHJlbn08L1N0eWxlZEJvZHk+O1xuIl19 */")), a = ({
  children: c
}) => /* @__PURE__ */ b(d, { children: c });
export {
  a as Body
};
